// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Recebimentos_CarregaRecebimentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /recebimentos/carrega_recebimento
 *
 * Returns a single recebimento record.
 *
 * DO NOT EDIT THIS FILE MANUALLY — it is the single source of truth for the
 * response shape. The TypeScript sibling is auto-generated from this file via
 * scripts/sync-contracts/sync-from-php.sh.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Recebimentos_CarregaRecebimentoResponseDados {
recebimento_numero_parcelas: number
recebimento_parcela_numero: number
recebimento_id?: number
recebimento_data_cadastro?: string
recebimento_data?: string
recebimento_franquia_id?: number
recebimento_franquia_nome?: string
recebimento_conta_id?: number
recebimento_conta_nome?: string
recebimento_forma_pagamento_id?: number
recebimento_forma_pagamento_nome?: string
recebimento_origem?: string
recebimento_origem_id?: number
recebimento_registrado_por?: string
recebimento_registrado_por_id?: string
recebimento_valor?: number
recebimento_provedor?: string
recebimento_id_externo?: string
recebimento_observacoes?: string
recebimento_conta_externa_id?: number
recebimento_data_disponivel?: string
recebimento_payroll_period_id?: number
recebimento_valor_taxas?: number
recebimento_valor_liquido?: number
recebimento_parcela_de?: number
}

export type Recebimentos_CarregaRecebimentoResponse = ApiResponse<Recebimentos_CarregaRecebimentoResponseDados>;

registerResponseContract('Recebimentos_CarregaRecebimentoResponse', {
  recebimento_numero_parcelas:      { type: 'number',  required: true },
  recebimento_parcela_numero:       { type: 'number',  required: true },
  recebimento_id:                   { type: 'number',  required: false },
  recebimento_data_cadastro:        { type: 'string',  required: false },
  recebimento_data:                 { type: 'string',  required: false },
  recebimento_franquia_id:          { type: 'number',  required: false },
  recebimento_franquia_nome:        { type: 'string',  required: false },
  recebimento_conta_id:             { type: 'number',  required: false },
  recebimento_conta_nome:           { type: 'string',  required: false },
  recebimento_forma_pagamento_id:   { type: 'number',  required: false },
  recebimento_forma_pagamento_nome: { type: 'string',  required: false },
  recebimento_origem:               { type: 'string',  required: false },
  recebimento_origem_id:            { type: 'number',  required: false },
  recebimento_registrado_por:       { type: 'string',  required: false },
  recebimento_registrado_por_id:    { type: 'string',  required: false },
  recebimento_valor:                { type: 'number',  required: false },
  recebimento_provedor:             { type: 'string',  required: false },
  recebimento_id_externo:           { type: 'string',  required: false },
  recebimento_observacoes:          { type: 'string',  required: false },
  recebimento_conta_externa_id:     { type: 'number',  required: false },
  recebimento_data_disponivel:      { type: 'string',  required: false },
  recebimento_payroll_period_id:    { type: 'number',  required: false },
  recebimento_valor_taxas:          { type: 'number',  required: false },
  recebimento_valor_liquido:        { type: 'number',  required: false },
  recebimento_parcela_de:           { type: 'number',  required: false },
})
